// Chinese translations
export const zh: Record<string, string> = {
  // Main Menu
  'menu.dashboard': '仪表板',
  'menu.orderNew': '产品登记',
  'menu.deliveryList': '交付清单',
  'menu.delivery': '交付',
  'menu.receipt': '打印收据/标签',
  'menu.definitions': '定义',
  'menu.customers': '客户',
  'menu.products': '产品定义',
  'menu.pricing': '价格定义',
  'menu.tailoring': '裁缝操作',
  'menu.attributes': '产品属性',
  'menu.users': '用户',
  'menu.productOrdering': '产品排序',
  'menu.discounts': '折扣定义',
  'menu.settings': '设置',
  'menu.generalSettings': '常规设置',
  'menu.permissions': '权限管理',
  'menu.subscription': '订阅',
  'menu.invoices': '发票管理',
  'menu.expenses': '费用录入',
  'menu.zReport': 'Z Report',
  'menu.reportsAndAccounting': '报表与财务',
  'menu.systemAndCommunication': '系统与通信',
  'menu.reportsList': '收据列表',
  'menu.accountStatement': '账户对账单',
  'menu.tickets': '支持请求',
  'menu.support': '支持',
  'menu.profile': '个人资料',
  'menu.logout': '退出',
  'menu.notifications': '短信/WhatsApp通知',
  'menu.whatsappConnection': 'WhatsApp连接',
  'menu.smsConnection': '短信连接',
  
  // Dashboard
  'dashboard.title': '仪表板',
  'dashboard.todaySales': '今日销售',
  'dashboard.totalOrders': '总订单',
  'dashboard.pendingDeliveries': '待交付',
  'dashboard.activeCustomers': '活跃客户',
  'dashboard.recentOrders': '最近订单',
  'dashboard.viewAll': '查看全部',
  'dashboard.quickActions': '快捷操作',
  'dashboard.newOrder': '新订单',
  'dashboard.newCustomer': '新客户',
  'dashboard.deliveries': '交付',
  'dashboard.reports': '报告',
  'dashboard.today': '今天',
  'dashboard.yesterday': '昨天',
  'dashboard.week': '周',
  'dashboard.month': '月',
  'dashboard.quarter': '季度',
  'dashboard.year': '年',
  'dashboard.totalRevenue': '总收入',
  'dashboard.totalOrdersCard': '总订单',
  'dashboard.totalPieces': '总件数',
  'dashboard.cancelled': '已取消',
  'dashboard.inProcess': '处理中',
  'dashboard.inProcessDesc': '处理中的订单',
  'dashboard.ready': '准备就绪',
  'dashboard.readyDesc': '准备交付的订单',
  'dashboard.delivered': '已交付',
  'dashboard.deliveredDesc': '已完成的订单',
  'dashboard.announcements': '公告',
  'dashboard.announcementAll': '一般',
  'dashboard.announcementPrivate': '私人',
  
  // Order Entry
  'order.title': '新订单',
  'order.customer': '客户',
  'order.selectCustomer': '选择客户',
  'order.newCustomer': '新客户',
  'order.products': '产品',
  'order.addProduct': '添加产品',
  'order.selectProduct': '选择产品',
  'order.quantity': '数量',
  'order.price': '价格',
  'order.total': '总计',
  'order.discount': '折扣',
  'order.subtotal': '小计',
  'order.tax': '增值税',
  'order.grandTotal': '总计',
  'order.payment': '支付',
  'order.paymentMethod': '支付方式',
  'order.cash': '现金',
  'order.card': '信用卡',
  'order.credit': '赊账',
  'order.amountPaid': '已付金额',
  'order.remainingBalance': '剩余余额',
  'order.deliveryDate': '交付日期',
  'order.notes': '备注',
  'order.createOrder': '创建订单',
  'order.cancel': '取消',
  
  // Users
  'users.title': '用户',
  'users.addNew': '新用户',
  'users.name': '姓名',
  'users.email': '电子邮件',
  'users.role': '角色',
  'users.pin': 'PIN码',
  'users.permissions': '权限',
  'users.allPermissions': '所有权限',
  'users.permissionCount': '{count} 权限',
  'users.changePin': '更改PIN码',
  'users.edit': '编辑',
  'users.delete': '删除',
  'users.newUser': '新用户',
  'users.editUser': '编辑用户',
  'users.editingUser': '编辑 {name}',
  'users.deleteUserTitle': '删除用户',
  'users.deletingUser': '确定要删除 {name} 吗？',
  'users.pinCode': 'PIN码（4-6位数字）',
  'users.selectRole': '选择角色',
  'users.patron': '老板',
  'users.kasiyer': '收银员',
  'users.sofor': '司机',
  'users.eleman': '员工',
  'users.changePinTitle': '更改PIN码',
  'users.newPin': '新PIN码',
  'users.confirmPin': '确认PIN码',
  'users.pinMismatch': 'PIN码不匹配',
  'users.pinRequired': '需要PIN码',
  'users.pinLength': 'PIN码必须为4-6位数字',
  'users.changingPinFor': '更改 {name} 的PIN码',
  
  // Products
  'products.title': '产品定义',
  'products.addNew': '新产品',
  'products.category': '类别',
  'products.name': '产品名称',
  'products.price': '价格',
  'products.color': '颜色',
  'products.active': '活跃',
  'products.actions': '操作',
  'products.search': '搜索产品...',
  'products.noProducts': '未找到产品',
  'products.noCategoryProducts': '此类别中没有产品',
  'products.emptyCart': '购物车为空',
  
  // Service Types
  'service.tailor': '裁缝',
  'service.dryCleaning': '干洗',
  'service.washing': '洗涤',
  'service.ironing': '熨烫',
  'service.shoeShine': '擦鞋',
  'service.carpet': '地毯',
  'service.tailoring': '裁缝修改',
  'service.carpetWashing': '地毯清洗',
  'service.sofaWashing': '沙发清洗',
  'service.carWash': '洗车与美容',
  'service.barber': '理发 / 美发',
  'service.selectService': '选择服务',
  'service.addToCart': '添加到购物车',
  'service.total': '总计',
  
  // Common
  'common.yes': '是',
  'common.no': '否',
  'common.cancel': '取消',
  'common.confirm': '确认',
  'common.delete': '删除',
  'common.edit': '编辑',
  'common.save': '保存',
  'common.search': '搜索',
  'common.loading': '加载中...',
  'common.noData': '无数据',
  'common.actions': '操作',
  'common.status': '状态',
  'common.date': '日期',
  'common.time': '时间',
  'common.total': '总计',
  'common.filter': '筛选',
  'common.export': '导出',
  'common.print': '打印',
  'common.close': '关闭',
  'common.back': '返回',
  'common.next': '下一页',
  'common.previous': '上一页',
  'common.submit': '提交',
  'common.reset': '重置',
  'common.create': '创建',
  'common.creating': '创建中...',
  'common.later': '稍后',
  'common.clear': '清除',
  'common.copied': '已复制！',
  'common.copyError': '复制失败',
  'common.perPage': '每页',
  'common.page': '页',
  'common.orders': '订单',
  'common.pieces': '件',
  
  // Login
  'login.title': 'Cleandy',
  'login.subtitle': '干洗管理系统',
  'login.tenantId': '公司ID',
  'login.tenantPlaceholder': '公司ID（例如：acme-clean）',
  'login.tenantIdHelp': '输入您的唯一公司标识符',
  'login.continue': '继续 →',
  'login.notMember': '还不是会员？',
  'login.startTrial': '开始免费试用',
  'login.adminLogin': '🔒 管理员登录',
  'login.enterPin': '输入您的PIN码',
  'login.changeTenant': '更改公司',
  'login.clear': '清除',
  'login.delete': '删除',
  'login.login': '登录',
  'login.loggingIn': '登录中...',
  'login.defaultPinOwner': '默认PIN码：<strong>1234</strong>（老板）',
  'login.defaultPinCashier': '默认PIN码：<strong>0000</strong>（收银员）',
  'login.systemInitializing': '系统初始化中...',
  'login.pinMinLength': 'PIN码必须至少为4位数字',
  'login.invalidTenantId': '输入有效的公司ID',
  'login.tenantNotFound': '未找到此公司代码。请检查或创建新账户。',
  'login.loginFailed': '登录失败',
  'login.welcome': '欢迎，{name}',

  // Signup translations
  'signup.title': '开始免费试用',
  'signup.subtitle': '15天免费试用，无需信用卡',
  'signup.backToLogin': '返回登录页面',
  'signup.companyCode': '公司代码',
  'signup.companyCodePlaceholder': '例如：cleanpro',
  'signup.companyCodeHelp': '此代码将用于登录系统',
  'signup.companyCodeMinLength': '公司代码必须至少3个字符',
  'signup.companyName': '公司名称',
  'signup.companyNamePlaceholder': '您的公司名称',
  'signup.companyNameRequired': '公司名称为必填项',
  'signup.fullName': '全名',
  'signup.fullNamePlaceholder': '您的全名',
  'signup.fullNameRequired': '全名为必填项',
  'signup.phone': '电话',
  'signup.phonePlaceholder': '+86 138 0000 0000',
  'signup.validPhoneRequired': '输入有效的电话号码',
  'signup.email': '电子邮件',
  'signup.emailPlaceholder': 'example@company.com',
  'signup.validEmailRequired': '输入有效的电子邮件地址',
  'signup.createAccount': '创建账户',
  'signup.creating': '创建中...',
  'signup.terms': '通过创建账户，您同意服务条款和隐私政策。',
  'signup.success': '注册成功！您的登录信息已发送到您的电子邮件地址。',
  'signup.successTitle': '注册成功！',
  'signup.successMessage': '您的账户已成功创建。',
  'signup.emailSent': '您的登录信息已发送到您的电子邮件地址。',
  'signup.redirecting': '正在重定向到登录页面...',
  'signup.startupPackageLoaded': '启动包已加载！',
  'signup.products': '产品',
  'signup.customers': '客户',
  'signup.users': '用户',
  'signup.demoDataReady': '✨ 您的演示数据已准备就绪，您可以立即开始使用！',
  'signup.loginInfo': '📧 您的登录信息',
  'signup.loginInfoSent': '💡 此信息也已发送到您的电子邮件地址',
  'signup.loginNow': '立即登录 →',
  'signup.hints.companyCode': '用于登录',
  'signup.hints.country': '您的国家已自动检测。您可以选择不同的国家。',
  'signup.freeTrial': '🎉 免费试用15天 - 无需信用卡！',
  'signup.businessType.question': '您从事什么行业？',
  'signup.businessType.hint': '您的默认界面将根据您的选择自动设置',
  'signup.businessType.continue': '继续',
  'signup.bt.dryCleaning.desc': '衣物、窗帘及纺织品清洗',
  'signup.bt.carpetWashing.desc': '地毯、地垫和走廊毯清洗',
  'signup.bt.shoeShine.desc': '鞋类清洁与护理',
  'signup.bt.sofaWashing.desc': '沙发、长椅和扶手椅清洗',
  'signup.bt.carWash.desc': '汽车清洗、打蜡和护理服务',
  'signup.bt.tailoring.desc': '裁缝、修改和缝纫服务',
  'signup.bt.barber.desc': '理发店、美发和美容沙龙',
  'toast.productsLoadError': '加载产品失败',
  'toast.statsLoadError': '加载统计数据失败',
  'toast.orderDetailsLoadError': '加载订单详情失败',
  'toast.orderLoadError': '加载订单失败',
  'toast.deliveryBeforeToday': '送货日期不能在今天之前',
  'toast.customerOpenOrders': '客户有 {count} 个未结订单',
  'toast.customerDebt': '客户欠款 {amount}',
  'toast.customerSaved': '客户已保存',
  'toast.customerSaveError': '保存客户失败',
  'toast.customerUpdated': '客户已更新',
  'toast.customerUpdateError': '更新客户失败',
  'toast.customerExistingSelected': '已选择现有客户',
  'toast.productAddedToCart': '产品已添加到购物车',
  'toast.productAdded': '产品已添加',
  'toast.productDetailsUpdated': '产品详情已更新',
  'toast.priceUpdated': '价格已更新',
  'toast.selectAtLeastOneService': '请至少选择一项服务',
  'toast.selectCustomer': '请选择客户',
  'toast.addProduct': '请添加产品',
  'toast.addressRequiredForDelivery': '送货上门需要客户地址',
  'toast.orderSaved': '订单已保存',
  'toast.orderSaveError': '保存订单失败',
  'toast.cardPaymentSuccess': '卡支付成功！',
  'toast.cardPaymentError': '卡支付失败',
  'toast.paymentFailedTryAgain': '支付失败。请重试。',
  'toast.paymentStatusCheckFailed': '无法检查支付状态。',
  'toast.customerPhoneNotFound': '未找到客户电话号码',
  'toast.whatsappSent': 'WhatsApp 消息已发送！ ✅',
  'toast.whatsappFailed': 'WhatsApp 消息发送失败',
  'toast.orderUpdateError': '更新订单失败',
  'toast.searchError': '搜索错误',
  'toast.orderNotFound': '未找到订单',
  'toast.editCancelled': '编辑已取消',
  'toast.noEditPermission': '您没有编辑过去订单的权限',
  'toast.selectAtLeastOneOperation': '请至少选择一项操作',
  'toast.tailorAddedToCart': '裁缝操作已添加到购物车',
  'toast.enterValidArea': '请输入有效的面积',
  'toast.enterValidAmount': '请输入有效的金额',
  'toast.amountExceedsRemaining': '金额不能超过剩余余额',
  'toast.fillAllCardInfo': '请填写所有卡信息',
  'toast.invalidCardNumber': '无效的卡号',
  'toast.invalidMonth': '无效的月份 (必须是 1-12)',
  'toast.invalidYear': '无效的年份',
  'toast.invalidCvc': '无效的 CVC',

  // Settings
  'settings.title': '设置',
  'settings.save': '保存',
  'settings.loading': '加载中...',
  'settings.general': '常规设置',
  'settings.languageRegion': '语言和地区',
  'settings.language': '语言',
  'settings.currency': '货币',
  'settings.currencyPosition': '货币位置',
  'settings.currencyPositionLeft': '左侧 (¥100)',
  'settings.currencyPositionRight': '右侧 (100¥)',
  'settings.numberFormat': '数字格式',
  'settings.numberFormatDotComma': '点号小数 (1.234,56)',
  'settings.numberFormatCommaDot': '逗号小数 (1,234.56)',
  'settings.numberFormatSpaceComma': '空格小数 (1 234,56)',
  'settings.showDecimals': '显示小数位',
  'settings.showDecimalsDesc': '金额显示2位小数',
  'settings.dateFormat': '日期格式',
  'settings.timezone': '时区',
  'settings.taxRate': '税率',
  'settings.receiptSettings': '收据设置',
  'settings.logo': '标志',
  'settings.removeLogo': '删除标志',
  'settings.uploadLogo': '上传标志',
  'settings.companyName': '公司名称',
  'settings.companyNamePlaceholder': '输入公司名称',
  'settings.phone': '电话',
  'settings.address': '地址',
  'settings.addressPlaceholder': '输入地址',
  'settings.footerText': '页脚文本',
  'settings.footerTextPlaceholder': '输入页脚文本',
  'settings.receiptNote': '收据备注',
  'settings.receiptNotePlaceholder': '输入收据备注',
  'settings.socialMedia': '社交媒体',
  'settings.website': '网站',
  'settings.dangerZone': '危险区域',
  'settings.deleteDemoData': '删除演示数据',
  'settings.deleteDemoDataTitle': '删除演示数据',
  'settings.deleteDemoDataConfirm': '此操作无法撤销！所有客户记录、订单、付款和支出将被删除。',
  'settings.productsWillBeKept': '产品将被保留',
  'settings.areYouSure': '你确定吗?',
  'settings.deleting': '删除中...',
  'settings.loadSchema': '加载架构',
  'settings.loadSchemaTitle': '加载数据库架构',
  'settings.loadSchemaConfirm': '这将创建数据库架构。继续吗？',
  'settings.connected': '已连接',
  'settings.notConnected': '未连接',
  'settings.connect': '连接',
  'settings.disconnect': '断开连接',
  'settings.showTax': '显示税',
  'settings.headerInfo': '头部信息',
  'settings.headerInfoPlaceholder': '例如: 干洗和熨烫',
  'settings.footerTextHelp': '收据底部显示的简短消息',
  'settings.receiptNoteHelp': '详细条款和条件',
  'settings.receiptPreview': '收据预览',
  'settings.expenses': '费用',
  'settings.invoices': '发票',
  'settings.reports': '报告',
  'settings.tickets': '支持工单',
  'settings.zReport': 'Z报告',

  // Receipt Page
  'receipt.title': '收据',
  'receipt.receiptNumber': '收据号',
  'receipt.date': '日期',
  'receipt.subtotal': '小计',
  'receipt.payment': '支付',
  'receipt.thankYou': '谢谢！',

  // 缺失的通用键
  'common.allYears': '所有年份',
  'common.autoDetected': '自动检测',
  'common.cancelled': '已取消',
  'common.clear': '清除',
  'common.items': '项目',
  'common.loadError': '加载失败',
  'common.none': '无',
  'common.paid': '已付款',
  'common.searchError': '搜索错误',
  'common.searchResults': '（搜索结果）',
  'common.unit': '单位',
  'common.year': '年',

  // 账户明细
  'accountStatement.allTime': '所有时间',
  'accountStatement.customer': '客户',
  'accountStatement.customerReceipts': '客户收据',
  'accountStatement.noData': '未找到账户明细',
  'accountStatement.noReceipts': '未找到收据',
  'accountStatement.payments': '付款',
  'accountStatement.period': '期间',
  'accountStatement.printStatement': '打印明细',
  'accountStatement.receipts': '收据',
  'accountStatement.remaining': '余额',
  'accountStatement.statement': '账户明细',
  'accountStatement.totalPaid': '已付总额',

  // 属性
  'attributes.color': '颜色',
  'attributes.deleteError': '无法删除属性',
  'attributes.deleted': '属性已删除',
  'attributes.name': '属性名称',
  'attributes.noAttributes': '未定义属性',
  'attributes.saveError': '无法保存属性',
  'attributes.saved': '属性已保存',
  'attributes.value': '值',

  // 客户明细
  'customerStatement.receiptDelivered': '已交付',
  'customerStatement.receiptOpen': '未结清',

  // 客户
  'customers.add': '添加客户',
  'customers.adres': '地址',
  'customers.cannotDeleteWithOrders': '有订单的客户不能删除',
  'customers.legacyHidden': '隐藏（旧）',
  'customers.notFound': '未找到客户',
  'customers.phoneMissing': '手机号缺失',
  'customers.telefon': '电话',
  'customers.telefon2': '电话 2',

  // 损坏
  'damage.add': '添加损坏',
  'damage.description': '描述',
  'damage.location': '位置',
  'damage.noPhoto': '无照片',
  'damage.photo': '照片',
  'damage.saveError': '无法保存损坏报告',
  'damage.saved': '损坏报告已保存',
  'damage.severity': '严重程度',
  'damage.title': '损坏报告',
  'damage.type': '损坏类型',

  // 仪表板
  'dashboard.allTime': '所有时间',
  'dashboard.referral.button': '复制邀请链接',
  'dashboard.referral.desc': '受邀商家注册后，额外获得 1 个月！',
  'dashboard.referral.title': '邀请好友',

  // 配送
  'delivery.complete': '配送',
  'delivery.deliveredItems': '已配送商品',
  'delivery.deliveredProducts': '已配送产品',
  'delivery.error': '配送错误',
  'delivery.noOrders': '未找到订单',
  'delivery.success': '配送成功',

  // 配送列表
  'deliveryList.address': '地址',
  'deliveryList.cancelButton': '取消',
  'deliveryList.cancelTitle': '取消订单',
  'deliveryList.complete': '完成',
  'deliveryList.completed': '已完成',
  'deliveryList.delivered': '已配送',
  'deliveryList.driver': '司机',
  'deliveryList.items': '商品',
  'deliveryList.noOrders': '无订单',
  'deliveryList.orderCancelled': '订单已取消',
  'deliveryList.orderDelivered': '订单已配送',
  'deliveryList.pending': '待处理',
  'deliveryList.phone': '电话',
  'deliveryList.selectDriver': '选择司机',
  'deliveryList.status': '状态',
  'deliveryList.title': '配送列表',

  // 司机
  'driver.searchHint': '请至少输入2个字符',
  'driver.searchPlaceholder': '收据号、姓名或电话...',

  // 页脚
  'footer.euServers': '欧盟服务器',
  'footer.gdpr': '符合GDPR',

  // 发票
  'invoices.downloading': '下载中...',

  // 登录
  'login.credentialsTitle': '登录凭证',
  'login.enterCredentials': '输入凭证',
  'login.forget': '忘记密码？',
  'login.saveCredentialsNote': '凭证已安全保存',
  'login.tagline': '干洗软件 — 为您的业务提供智能简便的解决方案。',
  'login.usernamePlaceholder': '输入用户名...',

  // 菜单
  'menu.driverPickup': '司机取件',
  'menu.hardware': '硬件',
  'menu.payment': '付款',
  'menu.reportsCharts': '报表与图表',

  // 导航
  'nav.logout': '退出登录',
  'nav.user': '用户',

  // 订单
  'order.amount': '金额',
  'order.homeDelivery': '上门配送',
  'order.processing': '处理中...',
  'orderCreate.selectOperation': '选择操作',
  'orderCreate.selectedOperations': '已选操作',

  // 付款
  'payment.bank': '银行转账',
  'payment.collect': '收款',
  'payment.credit': '赊账',
  'payment.free': '免费',
  'payment.paymentCare': '账户付款',
  'payment.paymentsSaved': '付款已保存',
  'payment.saveError': '无法保存付款',
  'payment.saved': '付款已保存',
  'payment.split': '分期付款',

  // 占位符
  'placeholder.customerAddress': '输入地址...',
  'placeholder.customerEmail': '输入邮箱...',
  'placeholder.customerName': '输入姓名...',
  'placeholder.customerNotes': '输入备注...',
  'placeholder.customerPhone': '输入电话...',

  // 定价
  'pricing.amount': '金额',
  'pricing.enterPrice': '输入价格',
  'pricing.percent': '百分比',

  // 产品
  'product.damage': '损坏',
  'product.stain': '污渍',

  // 收据
  'receipt.addressLabel': '地址',
  'receipt.allYears': '所有年份',
  'receipt.area': '面积',
  'receipt.backButton': '返回',
  'receipt.buyCredits': '购买点数',
  'receipt.cancelled': '已取消',
  'receipt.cancelledBanner': '此订单已取消',
  'receipt.cancelledBy': '取消者',
  'receipt.cancelledDate': '取消日期',
  'receipt.cancelledReason': '取消原因',
  'receipt.card': '银行卡',
  'receipt.cash': '现金',
  'receipt.change': '找零',
  'receipt.creditsFinished': 'WhatsApp点数已用完！',
  'receipt.customer': '客户',
  'receipt.customerInfo': '客户信息',
  'receipt.customerName': '客户姓名',
  'receipt.deliveryDate': '配送日期',
  'receipt.discount': '折扣',
  'receipt.freeOfCharge': '免费',
  'receipt.generalTotal': '总计',
  'receipt.grandTotal': '最终金额',
  'receipt.homeDelivery': '上门配送',
  'receipt.invalid': '无效收据',
  'receipt.items': '商品',
  'receipt.label': '标签',
  'receipt.markAsDelivered': '标记为已配送',
  'receipt.markAsReady': '标记为已就绪',
  'receipt.messageFailed': '消息发送失败',
  'receipt.messageSent': '消息已发送！',
  'receipt.new': '新收据',
  'receipt.noReceiptFound': '未找到收据',
  'receipt.notes': '备注',
  'receipt.onlyProEnterprise': '仅限Pro/Enterprise',
  'receipt.orderMarkedDelivered': '订单已标记为已配送',
  'receipt.orderMarkedReady': '订单已标记为已就绪',
  'receipt.orderNumber': '订单号',
  'receipt.paid': '已付款',
  'receipt.partialPayment': '部分付款',
  'receipt.paymentMethod': '付款方式',
  'receipt.phone': '电话',
  'receipt.phoneNotFound': '未找到电话号码',
  'receipt.piece': '件',
  'receipt.preview': '预览',
  'receipt.printError': '打印错误',
  'receipt.printerConnectError': '无法连接打印机',
  'receipt.remaining': '余额',
  'receipt.remainingCredits': '剩余点数',
  'receipt.reprint': '重新打印',
  'receipt.scanQR': '扫描二维码',
  'receipt.searchAll': '全部',
  'receipt.searchBy': '按...搜索',
  'receipt.searchName': '客户姓名',
  'receipt.searchPhone': '电话',
  'receipt.searchReceipt': '收据号',
  'receipt.searchTitle': '搜索收据',
  'receipt.sessionNotFound': '会话未找到，请重新登录。',
  'receipt.status': '状态',
  'receipt.thermalPrinter': '热敏打印机',
  'receipt.thisReceiptCancelled': '此收据已取消',
  'receipt.unknownError': '未知错误',
  'receipt.whatsappNotConnected': 'WhatsApp未连接！',
  'receipt.year': '年',

  // 报告
  'reports.averageOrder': '平均订单',
  'reports.ordersCount': '订单数量',
  'reports.salesReport': '销售报告',
  'reports.totalSales': '总销售额',

  // 服务
  'service.carpetShort': '地毯',
  'service.dryCleaningShort': '干洗',
  'service.ironingShort': '熨烫',
  'service.shoeShineShort': '鞋类',
  'service.tailoringShort': '裁缝',
  'service.washingShort': '水洗',

  // 设置
  'settings.africa': '非洲',
  'settings.americas': '美洲',
  'settings.asia': '亚洲',
  'settings.asiaPacific': '亚太地区',
  'settings.europe': '欧洲',
  'settings.integrations': '集成',
  'settings.notifications': '通知',
  'settings.printer': '打印机',
  'settings.printerConnect': '连接打印机',
  'settings.printerConnected': '打印机已连接',
  'settings.printerNotConnected': '打印机未连接',
  'settings.printerSettings': '打印机设置',
  'settings.saveError': '无法保存设置',
  'settings.saved': '设置已保存',
  'settings.testPrint': '测试打印',
  'settings.turkey': '土耳其',

  // 注册
  'signup.errors.companyCodeRequired': '公司代码为必填项',
  'signup.errors.companyNameRequired': '公司名称为必填项',
  'signup.errors.emailInvalid': '邮箱格式无效',
  'signup.errors.emailRequired': '邮箱为必填项',
  'signup.errors.ownerNameRequired': '所有者姓名为必填项',
  'signup.errors.signupFailed': '注册失败',
  'signup.referral.bonus': '推荐奖励',
  'signup.referral.title': '邀请码',

  // 状态
  'status.cancelled': '已取消',
  'status.delivered': '已配送',
  'status.pending': '待处理',
  'status.pickup_in_progress': '取件中',
  'status.pickup_pending': '待取件',
  'status.ready': '已就绪',
  'status.received': '已接收',

  // 订阅
  'subscription.buyNow': '立即购买',
  'subscription.cancel': '取消订阅',
  'subscription.contactSupport': '联系支持',
  'subscription.currentPlan': '当前套餐',
  'subscription.currentUsage': '当前用量',
  'subscription.daysLeft': '天剩余',
  'subscription.endDate': '结束日期',
  'subscription.expired': '已过期',
  'subscription.expiresOn': '到期于',
  'subscription.features': '功能',
  'subscription.loading': '加载订阅中...',
  'subscription.monthly': '月付',
  'subscription.monthlyLimit': '月度限额',
  'subscription.noSubscription': '无活跃订阅',
  'subscription.payNow': '立即付款',
  'subscription.plan': '套餐',
  'subscription.pro': 'Pro',
  'subscription.renew': '续订',
  'subscription.renewNow': '立即续订',
  'subscription.startDate': '开始日期',
  'subscription.title': '订阅',
  'subscription.trial': '试用',
  'subscription.trialDaysLeft': '天试用剩余',
  'subscription.upgrade': '升级',
  'subscription.yearly': '年付',

  // 支持票单
  'tickets.title': '支持票单',
  'tickets.newTicket': '新建票单',
  'tickets.noTickets': '无票单',
  'tickets.noTicketsDesc': '您还没有支持票单',
  'tickets.subject': '主题',
  'tickets.description': '描述',
  'tickets.created': '支持票单已创建',
  'tickets.createError': '无法创建支持票单',
  'tickets.loadError': '无法加载票单',
  'tickets.messages': '消息',
  'tickets.typeMessage': '输入消息...',
  'tickets.closed': '已关闭',
  'tickets.admin': '管理员',
  'tickets.ratingSubmitted': '评分已保存，谢谢！',
  'tickets.translationError': '翻译错误',
  'tickets.status.open': '开放',
  'tickets.status.closed': '已关闭',
  'tickets.rating.veryBad': '非常差',
  'tickets.rating.bad': '差',
  'tickets.rating.okay': '一般',
  'tickets.rating.good': '好',
  'tickets.rating.excellent': '优秀',

  // Toast通知
  'toast.logoTooLarge': 'Logo文件太大',
  'toast.logoUploadError': '无法上传Logo',
  'toast.uploadingLogo': '上传Logo中...',

  // WhatsApp
  'whatsapp.title': 'WhatsApp',
  'whatsapp.connect': '连接WhatsApp',
  'whatsapp.disconnect': '断开连接',
  'whatsapp.connected': '已连接',
  'whatsapp.scanQR': '扫描二维码',
  'whatsapp.status': '状态',
  'whatsapp.credits': '点数',
  'whatsapp.buyCredits': '购买点数',
  'whatsapp.creditPackages': '点数套餐',
  'whatsapp.messages': '消息',
  'whatsapp.creditsRemaining': '剩余点数',
  'whatsapp.noCredits': '无可用点数',
  'whatsapp.sendTest': '发送测试消息',
  'whatsapp.testSent': '测试消息已发送',
  'whatsapp.testFailed': '测试消息发送失败',
  'whatsapp.templates': '模板',
  'whatsapp.template': '模板',
  'whatsapp.preview': '预览',
  'whatsapp.save': '保存模板',
  'whatsapp.saved': '模板已保存',
  'whatsapp.orderReady': '订单已就绪',
  'whatsapp.orderDelivered': '订单已配送',
  'whatsapp.receiptCreated': '收据已创建',

  // Z报告
  'zReport.title': 'Z报告',
  'zReport.byEmployee': '按员工',
  'zReport.byProduct': '按产品',
  'zReport.byService': '按服务',
  'zReport.cardPayments': '刷卡付款',
  'zReport.cashIn': '收入',
  'zReport.cashOut': '支出',
  'zReport.cashPayments': '现金付款',
  'zReport.closingBalance': '期末余额',
  'zReport.creditPayments': '赊账付款',
  'zReport.custom': '自定义',
  'zReport.daily': '每日',
  'zReport.endDate': '结束日期',
  'zReport.freeOrders': '免费订单',
  'zReport.generateReport': '生成报告',
  'zReport.monthly': '每月',
  'zReport.newCustomers': '新客户',
  'zReport.openingBalance': '期初余额',
  'zReport.printReport': '打印报告',
  'zReport.returningCustomers': '回头客',
  'zReport.selectDate': '选择日期',
  'zReport.serviceBreakdown': '服务明细',
  'zReport.startDate': '开始日期',
  'zReport.totalCollected': '总收款',
  'zReport.totalItems': '总商品数',
  'zReport.totalOrders': '总订单数',
  'zReport.totalRefunds': '总退款',
  'zReport.totalRevenue': '总收入',
  'zReport.transferPayments': '转账付款',
  'zReport.weekly': '每周',
  'zreport.card': '银行卡',
  'zreport.cash': '现金',
  'zreport.date': '日期',
  'zreport.orders': '订单',
  'zreport.print': '打印',
  'zreport.title': 'Z报告',
  'zreport.total': '合计',

  'zReport.cashBoxStartNote': '收银初始余额',
  'zReport.todayCashNote': '今日收到现金',
  'zReport.branchCollectionsNote': '本店+其他分店收款',
  'zReport.dailyExpensesNote': '当日支出',
  'customerCard.balanceZero': '余额已为零。',
  'customerCard.debtLabel': '债务将被清除',
  'customerCard.creditLabel': '信用将被清除',
  'customerCard.resetConfirm': '余额将被重置（{label}）。确认？',
  'customerCard.resetSuccess': '余额已重置',
  'customerCard.resetError': '无法重置余额',
  'customerCard.printTitle': '客户卡',
  'customerCard.heading': '客户卡',
  'customerCard.tel1': '电话 1',
  'customerCard.tel2': '电话 2',
  'customerCard.address': '地址',
  'customerCard.printButton': '打印客户卡',
  'customerCard.resetting': '重置中...',
  'customerCard.resetBalance': '重置余额',
  'tailoring.loadError': '无法加载价格',
  'tailoring.nameRequired': '请输入操作名称',
  'tailoring.invalidPrice': '请输入有效价格',
  'tailoring.addSuccess': '新裁缝操作已添加！',
  'tailoring.saveError': '保存错误',
  'tailoring.deleteConfirm': '您确定要删除此操作吗？',
  'tailoring.deleteSuccess': '操作已删除',
  'tailoring.deleteError': '删除错误',
  'tailoring.saveSuccess': '裁缝价格已保存！',
  'tailoring.addNewTitle': '添加新裁缝操作',
  'tailoring.operationNameLabel': '操作名称',
  'tailoring.priceLabel': '价格',
  'tailoring.iconLabel': '图标（Emoji）',
  'tailoring.operationNamePlaceholder': '例：领口缝制',
  'tailoring.savePricesHint': '点击保存以保存价格',
  'tailoring.addCustomHint': '使用+按钮添加自定义操作',
  'reportsList.title': '收据列表报告',
  'reportsList.startDate': '开始日期',
  'reportsList.endDate': '结束日期',
  'reportsList.search': '搜索',
  'reportsList.loading': '加载中...',
  'reportsList.description': '列出此日期范围内记录或交付的所有收据',
  'reportsList.empty': '此日期范围内未找到收据',
  'reportsList.changeDateRange': '选择不同的日期范围',
  'reportsList.categoryBreakdown': '按类别分布',
  'reportsList.unknown': '未知',
  'reportsList.cancelReason': '取消原因：',
  'reportsList.excelDownloaded': 'Excel文件已下载',
  'reportsList.excelError': '无法创建Excel文件',
  'reportsList.totalReceipt': '总收据数',
  'reportsList.activeReceipt': '活跃收据',
  'reportsList.loadError': '无法加载收据列表',
  'reportsList.dateError': '开始日期不能晚于结束日期',
  'charts.revenue': '营业额',
  'charts.orders': '订单',
  'charts.pieces': '件数',
  'charts.receipts': '收据数',
  'charts.loadError': '无法加载数据',

  'customerStatement.selectDateRange': '选择日期范围',
  'customerStatement.thisMonth': '本月',
  'customerStatement.lastMonth': '上月',
  'customerStatement.allTime': '所有时间',
  'customerStatement.startDate': '开始日期',
  'customerStatement.endDate': '结束日期',
  'customerStatement.printPDF': '打印账单 (PDF)',
  'customerStatement.title': '客户账单',
  'customerStatement.customerName': '客户姓名',
  'customerStatement.phone': '电话',
  'customerStatement.address': '地址',
  'customerStatement.openingBalance': '期初余额',
  'customerStatement.closingBalance': '期末余额',
  'customerStatement.description': '描述',
  'customerStatement.type': '类型',
  'customerStatement.debit': '借方',
  'customerStatement.credit': '贷方',
  'customerStatement.total': '合计',
  'customerStatement.cancelled': '已取消',
  'customerStatement.payment': '付款',
  'customerStatement.items': '件',
  'customerStatement.noTransactions': '所选期间内没有交易记录。',
  'customerStatement.statementDate': '账单日期',

  'tailoring.title': '裁缝服务',
  'tailoring.addNew': '新建操作',
  'tailoring.subtitle': '您可以在此更新裁缝服务价格',
  'tailoring.addNewDescription': '添加自定义裁缝操作类型',
  'tailoring.add': '添加',
  'tailoring.savePrices': '保存价格',
  'tailoring.default': '默认',
  'tailoring.infoTitle': '信息',
  'tailoring.info1': '更改价格后，请点击"保存价格"',
  'tailoring.info2': '使用"新建操作"按钮可以添加自定义裁缝操作类型',
  'tailoring.info3': '可以使用垃圾桶图标删除自定义操作',
  'tailoring.info4': '这些价格在创建含裁缝服务的订单时使用',
  'tailoring.info5': '您可以为每个裁缝操作设置单独的价格',
  'tailoring.info6': '添加到购物车时自动计算价格',

  'hardware.title': '硬件商店',
  'hardware.subtitle': '收据打印机、标签打印机和来电显示设备',
  'hardware.cart': '购物车',
  'hardware.infoTitle': '信息',
  'hardware.infoText': '这些硬件产品目前只在土耳其销售。其他国家仅供参考。',
  'hardware.myCart': '我的购物车',
  'hardware.cartEmpty': '购物车为空',
  'hardware.vatSuffix': '+ 增值税',
  'hardware.total': '合计',
  'hardware.checkout': '去结算',
  'hardware.receiptPrinters': '收据打印机',
  'hardware.receiptPrintersSubtitle': '80mm热敏打印机，自动切纸',
  'hardware.compatibilityTitle': 'CleandySoft兼容性',
  'hardware.receiptCompatText': '适用于所有带自动切纸器的80mm热敏打印机。',
  'hardware.labelPrinters': '标签打印机',
  'hardware.labelPrintersSubtitle': '针式打印机，76mm/57mm (Epson TM-U220, Bixolon SRP-270)',
  'hardware.testedModels': '已测试型号',
  'hardware.labelCompatText': '已针对Epson TM-U220和Bixolon SRP-270进行测试。其他品牌或型号可能有问题。',
  'hardware.callerIdTitle': '来电显示设备',
  'hardware.callerIdSubtitle': '客户来电识别',
  'hardware.compatibilityNote': '兼容性说明',
  'hardware.callerIdCompatText': '仅针对CIDShow 2行型号测试。其他品牌或型号可能有效但不保证。',
  'hardware.barcodeScanners': '条形码扫描仪',
  'hardware.barcodeScannerSubtitle': 'USB条形码和二维码扫描仪',
  'hardware.barcodeCompatText': '所有2D条形码扫描仪均可与CleandySoft配合使用。USB HID模式的扫描仪自动支持。',
  'hardware.driverDownloads': '驱动程序和软件下载',
  'hardware.driverDownloadsText': '建议在连接打印机之前下载适当的驱动程序。',
  'hardware.onlyTurkey': '此产品仅在土耳其销售',
  'hardware.addedToCart': '已添加到购物车！',
  'hardware.available': '有货',
  'hardware.info': '信息',
  'hardware.features': '功能',
  'hardware.addToCart': '加入购物车',
  'hardware.infoOnly': '仅供参考',
  'expenses.expenseType': '费用类型',
  'expenses.allBranches': '所有分支机构',
  'expenses.noBranch': '无分支机构',
  'expenses.allTypes': '所有类型',
  'expenses.categoryBy': '按类别',
  'expenses.records': '条记录',
  'expenses.exportExcel': 'Excel',
  'expenses.excelError': '无法创建Excel文件',
  'expenses.branchSelect': '选择分支机构',
  'expenses.noBranchSelected': '— 未选择分支机构 —',
  'expenses.myBranch': '我的分支机构',
  'expenses.canOnlyDeleteToday': '您只能删除今天输入的费用。',
  'subscription.referralDesc': '您邀请的朋友注册并成为会员后，您将获得额外 1 个月！仅发送邀请不计入。',
};
